import React from 'react';
import { detect } from "detect-browser";
import { trackMessage } from "@forwardfinancing/analytics-frontend-library";

const supportedSystems = [
  "chrome",
  "firefox",
  "safari",
  "ios",
  "edge",
  "crios", // Chrome iOS
  "fxios", // Firefox iOS
  "ios-webview",
  "edge-chromium",
  "chromium-webview",
  "android"
];

const BrowserDetector = () => {
  const browser = detect();

  if (browser && supportedSystems.includes(browser.name)) {
    return null;
  } else {
    trackMessage({ messageInfo: 'Browser not supported' });
    return (
      <div className="browser-detector title is-5">
        You are not using a supported browser, please use the latest version of
        Chrome, Firefox or Safari
      </div>
    );
  }
};

export default BrowserDetector;
